"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParents = exports.getRelations = exports.getDescendants = exports.getAncestors = void 0;
const casing_1 = require("./casing");
const lists_1 = require("./lists");
const getAncestors = (configuration, menuItemConfigs, traversed = {}, sourcePath = []) => {
    const ancestors = [];
    for (const parent of (0, exports.getParents)(configuration, menuItemConfigs)) {
        if (!parent.primaryRelationship)
            continue;
        const hash = `${parent.collection}:${parent.name}`;
        if (traversed[hash])
            continue;
        traversed[hash] = true;
        const parentSourcePath = [
            ...sourcePath,
            {
                collection: parent.collection,
                name: parent.name,
            },
        ];
        ancestors.push({
            collection: parent.collection,
            name: parent.collectionCasing.pluralCamel,
            sourcePath: parentSourcePath,
        });
        ancestors.push(...(0, exports.getAncestors)(menuItemConfigs[parent.collection], menuItemConfigs, traversed, parentSourcePath));
    }
    return ancestors;
};
exports.getAncestors = getAncestors;
const getDescendants = (configuration, menuItemConfigs, traversed = {}, sourcePath = []) => {
    const descendants = [];
    for (const child of configuration.lists) {
        if (!child.primaryRelationship)
            continue;
        const hash = `${child.collection}:${child.name}`;
        if (traversed[hash])
            continue;
        traversed[hash] = true;
        const childSourcePath = [
            ...sourcePath,
            {
                collection: child.collection,
                name: child.name,
            },
        ];
        descendants.push({
            collection: child.collection,
            name: child.name,
            sourcePath: childSourcePath,
        });
        descendants.push(...(0, exports.getDescendants)(menuItemConfigs[child.collection], menuItemConfigs, traversed, childSourcePath));
    }
    return descendants;
};
exports.getDescendants = getDescendants;
const getRelations = (configuration, menuItemConfigs) => {
    return {
        ancestors: (0, exports.getAncestors)(configuration, menuItemConfigs),
        descendants: (0, exports.getDescendants)(configuration, menuItemConfigs),
    };
};
exports.getRelations = getRelations;
const getParents = (configuration, menuItemConfigs) => Object.values(menuItemConfigs).reduce((acc, config) => {
    const { name, lists } = config;
    (0, lists_1.getLists)(lists, menuItemConfigs).forEach((list) => {
        if (list.collection === configuration.name)
            acc.push({
                ...list,
                collection: name,
                collectionCasing: (0, casing_1.getCasing)(config),
            });
    });
    return acc;
}, []);
exports.getParents = getParents;
//# sourceMappingURL=relatives.js.map